import { render, staticRenderFns } from "./set_password.vue?vue&type=template&id=c85aff54&scoped=true"
import script from "./set_password.vue?vue&type=script&lang=js"
export * from "./set_password.vue?vue&type=script&lang=js"
import style0 from "./set_password.vue?vue&type=style&index=0&id=c85aff54&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c85aff54",
  null
  
)

export default component.exports